export const LIGHT_MODE = 'usingLightMode';
export const HIGH_CONTRAST = 'highContrast';
export const COMPACT_VIEW = 'usingCompactView';
export const TOKEN = 'token';
export const LOGOUT_REASON = 'logout-reason';